import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-238a6f00"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "placeholder", "disabled", "autocomplete"]

import { PropType, computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePasswordForm',
  props: {
  placeholder: {
    type: String as PropType<HTMLInputElement['placeholder']>,
    default: '',
  },
  modelValue: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  autocomplete: {
    type: String,
    default: 'off',
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props



const shownPassword = ref(false);
const toggleShownPassword = () => {
  shownPassword.value = !shownPassword.value;
};

const inputType = computed(() => {
  return shownPassword.value ? 'text' : 'password';
});
const iconType = computed(() => {
  return shownPassword.value ? 'icon_eye_close' : 'icon_eye_open';
});



const value = computed({
  get: () => props.modelValue,
  set: (value) => {
    value = value.replace(/</g, '＜');
    value = value.replace(/>/g, '＞');
    emit('update:modelValue', value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base_password_form", { 'is-error': props.isError }])
  }, [
    _withDirectives(_createElementVNode("input", {
      class: "base_password_form_form",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      type: _unref(inputType),
      placeholder: props.placeholder,
      disabled: props.disabled,
      autocomplete: props.autocomplete
    }, null, 8, _hoisted_1), [
      [_vModelDynamic, _unref(value)]
    ]),
    _createElementVNode("button", {
      class: _normalizeClass(["base_password_form_icon", _unref(iconType)]),
      onClick: toggleShownPassword,
      tabindex: "-1"
    }, null, 2)
  ], 2))
}
}

})